<div class="input-group flex-nowrap" *ngIf="!isDisabled">
  <span class="input-group-text"><i class="bi {{ iconClass }}"></i> </span>
  <input [(ngModel)]="localValue" (ngModelChange)="onValueChange($event)" type="text"
    class="form-control form-control-lg" placeholder="{{ placeholder }}" />
</div>
<div class="input-group disabled flex-nowrap" *ngIf="isDisabled">
  <span class="input-group-text"><i class="bi {{ iconClass }}"></i> </span>
  <input readonly="" [(ngModel)]="localValue" type="text" class="form-control form-control-lg"
    placeholder="{{ placeholder }}" />
</div>
